import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users/users.component';
import { UsersAddComponent } from './users-add/users-add.component';
import { UsersViewComponent } from './users-view/users-view.component';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalModule } from '../modal/modal.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from '../pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from '../shared-components-module/material.module';

const routes: Routes = [
  {path: 'users', component: UsersComponent},
  {path: 'users/new', component: UsersAddComponent},
  {path: 'users/new/:client', component: UsersAddComponent},
  {path: 'users/review', component: UsersViewComponent},
  {path: 'users/review/:user/:client', component: UsersViewComponent},
];

@NgModule({
  declarations: [
    UsersComponent,
    UsersAddComponent,
    UsersViewComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgbdModalModule,
    AngularEditorModule,
    PipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedComponentsModule,
    RouterModule.forRoot(routes),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }), // ToastrModule added

  ],
  exports:[]
})
export class UsersModule { }

